import { render, staticRenderFns } from "./subFooter.vue?vue&type=template&id=5be31ebc"
import script from "./subFooter.vue?vue&type=script&lang=js"
export * from "./subFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports